import React from 'react';
import { MessageSquare } from 'lucide-react';
import NotificationDropdown from './NotificationDropdown';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

/** Messages targeted at this user / organization (Notification endpoints). */
const TargetedNotificationWindow = ({ userId, organizationId }) => {
  const source = {
    title: 'Messages',
    icon: MessageSquare,
    enabled: !!userId,
    listUrl: (pageNum, type) =>
      `${apiBaseUrl}/Notification?pageNumber=${pageNum}&pageSize=10&type=${type}&userId=${userId}&organizationId=${organizationId}`,
    extractList: (response) => response.data.data?.data,
    countUrl: () => `${apiBaseUrl}/Notification/unread?organizationId=${organizationId}&userId=${userId}`,
    markReadUrl: (id) => `${apiBaseUrl}/Notification/markAsRead?notificationId=${id}&userId=${userId}`,
    getId: (notification) => notification.id,
  };

  return <NotificationDropdown source={source} />;
};

export default TargetedNotificationWindow;
